import { render } from "./ArbeitsplatzDerZukunft.vue?vue&type=template&id=56225916&scoped=true"
import script from "./ArbeitsplatzDerZukunft.vue?vue&type=script&lang=js"
export * from "./ArbeitsplatzDerZukunft.vue?vue&type=script&lang=js"

import "./ArbeitsplatzDerZukunft.vue?vue&type=style&index=0&id=56225916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56225916"]])

export default __exports__